import type { ClientMessage } from "@shared/protocol";
import { useAppStore } from "../store/appStore";
import { TerminalPanel } from "./TerminalPanel";

interface Props {
  send: (msg: ClientMessage) => boolean;
  registerWriter: (agentId: string, write: (data: string) => void) => () => void;
}

export function PanelGrid({ send, registerWriter }: Props) {
  const { panels, layout, activeWorkspace, workspaces } = useAppStore();
  const limit = layout === "full" ? 1 : layout === "1x2" ? 2 : layout === "1x3" ? 3 : 4;
  // Panels are workspace-scoped: only show sessions whose workspacePath sits
  // under the currently-selected workspace. The cwd identity is the canonical
  // owner; workspaceName is just a label.
  const activePath = workspaces.find((w) => w.id === activeWorkspace)?.path;
  const visible = panels.filter((p) => !activePath || p.workspacePath === activePath).slice(0, limit);

  if (visible.length === 0) {
    return (
      <main className="main">
        <div className={`panel-grid layout-${layout}`}>
          <section className="panel" style={{ alignItems: "center", justifyContent: "center", color: "var(--color-fg-subtle)" }}>
            <div style={{ textAlign: "center", padding: "2rem" }}>
              <div className="serif" style={{ fontSize: 22, color: "var(--color-fg)" }}>Noch keine <em>Session</em></div>
              <div style={{ marginTop: 8, fontSize: 13 }}>⌘N startet eine neue Claude-Session im aktiven Workspace.</div>
            </div>
          </section>
        </div>
      </main>
    );
  }

  return (
    <main className="main">
      <div className={`panel-grid layout-${layout}`}>
        {visible.map((p) => (
          <TerminalPanel key={p.agentId} panel={p} send={send} registerWriter={registerWriter} />
        ))}
      </div>
    </main>
  );
}
